import Vue from 'vue' //引入Vue
import Router from 'vue-router' //引入vue-router

Vue.use(Router)  //Vue全局使用Router

export default new Router({
    mode: 'history',
    routes: [
        {
            path: '/login',
            name: 'QwePage',
            component: () => import('../vivce/QwePage.vue')
        },
        {
            path: '/callingCard',
            name: 'CallingCardPage',
            component: () => import('../vivce/callingCard.vue')
        },
        {
            path: '/phoneBook',
            name: 'PhoneBookPage',
            component: () => import('../vivce/phoneBook.vue')
        },
        {
            path: '/addContacts',
            name: 'AddContactsPage',
            component: () => import('../vivce/addContacts.vue')
        },
        {
            path: '/home',
            name: 'HomePage',
            component: () => import('../vivce/home.vue')
        },
        {
            path: '/commodity',
            name: 'CommodityPage',
            component: () => import('../vivce/commodity.vue')
        },
        {
            path: '/index',
            name: 'IndexPage',
            component: () => import('../vivce/index.vue')
        },
        {
            path: '/delContacts',
            name: 'DelContactsPage',
            component: () => import('../vivce/delContacts.vue')
        },
        {
            path: '/payouts',
            name: 'PayoutsPage',
            component: () => import('../vivce/payouts.vue')
        },
// {
//     path:'/hi',
//         component
// :
//     Hi,
//         children
// :
//     [        //子路由,嵌套路由 （此处偷个懒，免得单独再列一点）
//         {path: '/', component: Hi},
//         {path: 'hi1', component: Hi1},
//         {path: 'hi2', component: Hi2},
//     ]
// }
    ]
})
